/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IRemoteDto } from "./i-remote-dto";
import { IContainsDictionariesRemoteDto } from "./i-contains-dictionaries-remote-dto";
import { CallInformationRemoteDto } from "./call-information-remote-dto";

export class SamwinLineStatusRemoteDto implements IRemoteDto, IContainsDictionariesRemoteDto {
    dictionaryProperties: string[] = ["Fields"];
    callId: number;
    dn: string;
    name: string;
    fields: { [key: string]: string; };
    history: CallInformationRemoteDto[];
    lineState: string;
    ici: CallInformationRemoteDto;
    connectedSince: Date;
}
